import { render, staticRenderFns } from "./TableOrderList.vue?vue&type=template&id=a8577f44&scoped=true"
import script from "./TableOrderList.vue?vue&type=script&lang=js"
export * from "./TableOrderList.vue?vue&type=script&lang=js"
import style0 from "./TableOrderList.vue?vue&type=style&index=0&id=a8577f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8577f44",
  null
  
)

export default component.exports